import { Match } from '@/utils/types';
import { CommonProps } from '@nrldigitaltechnology/ui-community/dist/components/Matchcentre/types';
import { create } from 'zustand';
import { persist } from "zustand/middleware";

interface MatchStore {
    match: Match | null;
    setMatch: (match: Match) => void;
    clearMatch: () => void;
  }


  export const useMatchStore = create<MatchStore>((set) => ({
    match: null,
    setMatch: (match) => set({ match }),
    clearMatch: () => set({ match: null }),
  }));

  interface ExperienceStore {
    data:{heroImage : string} | null,
    setExperience: (experience: any) => void;
    clearExperience: () => void;
  }

  export const useRootExperience = create<ExperienceStore>((set) => ({
    data: null,
    setExperience: (data : {heroImage : string}) => set({ data }),
    clearExperience: () => set({ data: null }),
  }))


  // interface StateRegionStore {
  //   state:CommonProps,
  //   region:CommonProps,
  //   association:CommonProps,
  //   setState: (state:CommonProps) => void;
  //   setRegion: (region:CommonProps) => void;
  //   setAssociation: (association:CommonProps) => void;
  //   clearState: () => void;
  //   clearRegion: () => void;
  // }

  // export const useStateRegionStore = create<StateRegionStore>((set) => ({
  //   state: {} as CommonProps,
  //   region: {} as CommonProps,
  //   association: {} as CommonProps,
  //   setState: (state) => set({ state }),
  //   setRegion: (region) => set({ region }),
  //   setAssociation: (association) => set({ association }),
  //   clearState: () => set({ state: {} as CommonProps }),
  //   clearRegion: () => set({ region: {} as CommonProps }),
  //   clearAssociation: () => set({ region: {} as CommonProps }),
  // }));

  interface StateRegionStore {
    state: CommonProps;
    region: CommonProps;
    association: CommonProps;
    club:CommonProps;
    team:CommonProps;
    competition:CommonProps;
    setState: (state: CommonProps) => void;
    setRegion: (region: CommonProps) => void;
    setAssociation: (association: CommonProps) => void;
    setClub: (club: CommonProps) => void;
    setTeam: (team: CommonProps) => void;
    setCompetition: (competition: CommonProps) => void;
    clearState: () => void;
    clearRegion: () => void;
    clearAssociation: () => void;
    clearClub: () => void;
    clearTeam: () => void;
    clearCompetition: () => void;
    clearAll: () => void;
    resetToDefaults: () => void;
  }
  
  export const useStateRegionStore = create<StateRegionStore>()(
    persist(
      (set) => ({
        state: {} as CommonProps,
        region: {} as CommonProps,
        association: {} as CommonProps,
        club:{} as CommonProps,
        team:{} as CommonProps,
        competition:{} as CommonProps,
        setState: (state) => set({ state }),
        setRegion: (region) => set({ region }),
        setAssociation: (association) => set({ association }),
        setClub: (club) => set({ club }),
        setTeam: (team) => set({ team }),
        setCompetition: (competition) => set({ competition }),
    
  
        clearState: () => set({ state: {} as CommonProps }),
        clearRegion: () => set({ region: {} as CommonProps }),
        clearAssociation: () => set({ association: {} as CommonProps }),
        clearClub: () => set({ club: {} as CommonProps }),
        clearTeam: () => set({ team: {} as CommonProps }),
        clearCompetition: () => set({ competition: {} as CommonProps }),
        clearAll: () => set({
          state: {} as CommonProps,
          region: {} as CommonProps,
          association: {} as CommonProps,
          club: {} as CommonProps,
          team: {} as CommonProps,
          competition: {} as CommonProps,
        }),
        resetToDefaults: () => set({
          state: {} as CommonProps,
          region: {} as CommonProps,
          association: {} as CommonProps,
          club: {} as CommonProps,
          team: {} as CommonProps,
          competition: {} as CommonProps,
        }),
      }),
  
      {
        name: "state-region-storage",
      }
    )
  );

  interface LoaderStore {
    loading: boolean;
    setLoading: (loading: boolean) => void;
  }

  export const useLoaderStore = create<LoaderStore>((set) => ({
    loading: false,
    setLoading: (loading) => set({ loading }),
  }));